// extracted by mini-css-extract-plugin
export default {"app_loading":"loading_app_loading__U2qVm","app_loading_icon":"loading_app_loading_icon__8l3Cq","app_loading_tip":"loading_app_loading_tip__3fowD"};